import { render } from "./status.html?vue&type=template&id=25eca15e&scoped=true&ts=true"
import script from "./status.ts?vue&type=script&lang=ts"
export * from "./status.ts?vue&type=script&lang=ts"

import "./status.scss?vue&type=style&index=0&id=25eca15e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25eca15e"]])

export default __exports__